import { useEffect } from 'react';
import { faRobot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useChatStore } from '../hooks/useChatStore';

const LAUNCHER_SPACE_VARIABLE = '--ai-launcher-space';
const LAUNCHER_SPACE = '4.25rem';

export function ChatLauncherButton() {
  const { t } = useTranslation();
  const open = useChatStore((state) => state.open);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty(LAUNCHER_SPACE_VARIABLE, LAUNCHER_SPACE);
    return () => {
      root.style.removeProperty(LAUNCHER_SPACE_VARIABLE);
    };
  }, []);

  return (
    <Button
      variant="ghost"
      iconOnly
      aria-label={t('domain.ai.chat.open')}
      onClick={open}
      className="fixed right-4 bottom-4 z-40 size-10 bg-backgrounds-primary text-brand-red-200 shadow hover:bg-neutrals-v2-200">
      <FontAwesomeIcon icon={faRobot} className="size-5" />
    </Button>
  );
}
